import React, { useRef } from 'react';

import { ContentWrapper } from '../../../../components/ContentWrapper/ContentWrapper';
import { SwitchType } from '../../../../hooks/useSwitch';
import { HistoryItem } from '../../../../store/reducers/currentSequencedFlowPositionReducer';
import { useContentRequirementsContext } from '../../../RestrictNavigation/ContentRequirementsProvider';
import { ItemViewed } from '../../../tracking/components/functional/ItemViewed';
import { useSequencedContentFlowContext } from '../../context/SequencedContentFlowContext';
import { LinearFlowStepAudioPlayer } from '../LinearFlowStepAudioPlayer';
import { useContentDisplayed } from '../mobile/hooks/useContentDisplayed';
import { Navigation } from '../Navigation';
import { SequencedFlowContent } from './SequencedFlowContent';
import { Section, SequencedFlowChildrenTypes } from '@ael/core-api';
import { Stack } from 'immutable';
import { FroalaEditorsSettings } from 'src/config/configs';

interface DesktopSequencedFlowProps {
  currentContentItem: SequencedFlowChildrenTypes;
  history: Stack<HistoryItem>;
  panelVisibility: SwitchType;
  onGoToSection: (section: Section) => void;
  froalaEditorsSettings: FroalaEditorsSettings;
}

export const DesktopSequencedFlow: React.FC<DesktopSequencedFlowProps> = React.memo(
  ({ currentContentItem, onGoToSection, history, panelVisibility, froalaEditorsSettings }) => {
    const { isLastContentItem, sequencedFlowItem } = useSequencedContentFlowContext();
    const requirements = useContentRequirementsContext();

    const { contentDisplayed } = useContentDisplayed(currentContentItem);
    const toolbarRef = useRef(null);

    return (
      <ContentWrapper>
        <SequencedFlowContent
          currentContentItem={currentContentItem}
          isContentCollapsed={!contentDisplayed}
          onGoToSection={onGoToSection}
          panelVisibility={panelVisibility}
          froalaEditorsSettings={froalaEditorsSettings}
        />
        <ContentWrapper.Toolbar ref={toolbarRef}>
          <>
            {isLastContentItem && <ItemViewed itemId={sequencedFlowItem.id} isCompleted={requirements.fulfilled} />}
            <Navigation
              audioPlayer={<LinearFlowStepAudioPlayer linearFlowStep={currentContentItem} isMobile={false} />}
              history={history}
              ref={toolbarRef}
              isDisplayedOnMobile={false}
            />
          </>
        </ContentWrapper.Toolbar>
        <ContentWrapper.Caption />
      </ContentWrapper>
    );
  }
);
